<div class="form-group">
  <label for="prod-m">{{ 'form.price_lists'| translate }}</label>
  <angular2-multiselect [data]="list"
      [(ngModel)]="listsSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onElementSelect()"
      (onSelectAll)="onElementSelect()"
      (onDeSelectAll)="onElementSelect()"
      (onFilterSelectAll)="onElementSelect()"
      (onFilterDeSelectAll)="onElementSelect()">
  </angular2-multiselect>
</div>